import { __rest } from "tslib";
import { ALLOW_ALL_KEY, CONSENT_STORAGE_NAME } from './constants';
export const ConsentStorage = {
    allowAll() {
        return ConsentStorage.setProvider(ALLOW_ALL_KEY);
    },
    getAllProviders() {
        const _a = ConsentStorage.getStorage(), _b = ALLOW_ALL_KEY, _ = _a[_b], providers = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return providers;
    },
    getProvider(hostName) {
        const storage = ConsentStorage.getStorage();
        const key = hostName === null || hostName === void 0 ? void 0 : hostName.toLowerCase();
        return storage[key];
    },
    getStorage() {
        const value = localStorage.getItem(CONSENT_STORAGE_NAME);
        return value ? JSON.parse(value) : {};
    },
    hasProvider(hostName) {
        return Boolean(ConsentStorage.getProvider(hostName));
    },
    isProviderAllowed(hostName) {
        const storage = ConsentStorage.getStorage();
        const key = hostName === null || hostName === void 0 ? void 0 : hostName.toLowerCase();
        const allowAll = Boolean(storage[ALLOW_ALL_KEY]);
        return allowAll || Boolean(storage[key]);
    },
    removeAllowAll() {
        return ConsentStorage.removeProvider(ALLOW_ALL_KEY);
    },
    removeProvider(hostName) {
        const currentState = ConsentStorage.getStorage();
        const key = hostName === null || hostName === void 0 ? void 0 : hostName.toLowerCase();
        if (key) {
            const _a = currentState, _b = key, _ = _a[_b], nextState = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            localStorage.setItem(CONSENT_STORAGE_NAME, JSON.stringify(nextState));
            return nextState;
        }
        return currentState;
    },
    resetStorage() {
        localStorage.removeItem(CONSENT_STORAGE_NAME);
    },
    setProvider(hostName, displayName) {
        const currentState = ConsentStorage.getStorage();
        const key = hostName === null || hostName === void 0 ? void 0 : hostName.toLowerCase();
        const name = displayName !== null && displayName !== void 0 ? displayName : hostName;
        if (key) {
            const nextState = Object.assign(Object.assign({}, currentState), { [key]: name });
            localStorage.setItem(CONSENT_STORAGE_NAME, JSON.stringify(nextState));
            return nextState;
        }
        return currentState;
    },
};
//# sourceMappingURL=ConsentStorage.js.map